const rules = {
	user: {
		static: [],
	},

	// 👨‍💼 SUPERVISOR: Todas as permissões do admin EXCETO o menu ADMINISTRAÇÃO
	supervisor: {
		static: [
			// ❌ "dashboard:view" - removido para ocultar menu ADMINISTRAÇÃO
			"drawer-admin-items:view", // ✅ Necessário para liberar o menu Gestão
			"user-modal:editQueues", // ✅ Pode gerenciar filas dos usuários
			"tickets-manager:showall", // ✅ Ver todos os tickets
			"ticket-options:deleteTicket", // ✅ Deletar tickets
			"contacts-page:deleteContact", // ✅ Deletar contatos
			"contacts-page:deleteAllContacts", // ✅ Deletar todos contatos
			"connections-page:actionButtons", // ✅ Ações em conexões
			"connections-page:addConnection", // ✅ Adicionar conexões
			"connections-page:editOrDeleteConnection", // ✅ Editar/deletar conexões
			"tickets-manager:closeAll", // ✅ Fechar todos os tickets
		],
	},

	admin: {
		static: [
			"dashboard:view",
			"drawer-admin-items:view",
			"tickets-manager:showall",
			"user-modal:editProfile",
			"user-modal:editQueues",
			"ticket-options:deleteTicket",
			"contacts-page:deleteContact",
			"contacts-page:deleteAllContacts",
			"connections-page:actionButtons",
			"connections-page:addConnection",
			"connections-page:editOrDeleteConnection",
			"tickets-manager:closeAll",
		],
	},
};

export default rules;
